import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { PatchSharePlanDto } from '../../types/pool-plans.types';
import { useAppMutation } from '../use-app-mutation.hook';

export const useUpdate = () => {
  const { mutate: update, isPending } = useAppMutation([QueryKey.PATCH_SHARE_PLAN], {
    mutationFn: ({
      companyId,
      data,
      planId,
    }: {
      companyId: string;
      data: PatchSharePlanDto;
      planId: string;
    }) =>
      ApiService.patch(
        { endpoint: BackendRoute.COMPANIES, routePath: [companyId, 'share-plans', planId] },
        {
          body: data,
        },
      ),
  });
  return { update, isPending };
};
